// import hooks
import { useState, useCallback, useId, useMemo } from "react";
export const usePopMenuHook = () => {
    const buttonId = useId();
    const menuId = useId();
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const clickHandler = useCallback((event) => {
        setAnchorEl(event.currentTarget);
    }, []);
    const closeHandler = useCallback(() => {
        setAnchorEl(null);
    }, []);
    const buttonAriaProps = useMemo(() => ({
        id: buttonId,
        "aria-controls": open ? menuId : undefined,
        "aria-haspopup": "true",
        "aria-expanded": open ? "true" : undefined,
    }), [buttonId, menuId, open]);
    const menuAriaProps = useMemo(() => ({ id: menuId }), [menuId]);
    const menuListAriaProps = useMemo(() => ({
        "aria-labelledby": buttonId,
    }), [buttonId]);
    return { open, clickHandler, closeHandler, anchorEl, buttonAriaProps, menuAriaProps, menuListAriaProps };
};
export default usePopMenuHook;
